import { useLocation } from "react-router-dom";
import { CardListPage } from "components/Category/Category";
import { formatCountriesRow } from "./CountriesList.formatters";
import { getCrudItems } from "./CountriesList.crud";
import {
  rowCellOptions,
  COUNTRIES_LIST_COLUMNS,
  COUNTRIES_LIST_ENDPOINTS,
} from "./CountriesList.config";
import { CountriesRow, CountriesListProps } from "./CountriesList.types";

/**
 * Custom hook to generate all Category component props for Countries.
 * @param props - Countries list component props.
 * @param location - React Router location object.
 * @returns Object containing all props needed for the Category component.
 */
export function useCountriesCategoryProps(
  props: CountriesListProps,
  location: ReturnType<typeof useLocation>
) {
  const crudItems = getCrudItems();

  return {
    location,
    noun: "country",
    idColumn: COUNTRIES_LIST_COLUMNS.Id,
    listEndpointUrl: COUNTRIES_LIST_ENDPOINTS.list,
    defaultBActiveFilterColumnKey: COUNTRIES_LIST_COLUMNS.Active,
    rowFormatter: formatCountriesRow,
    hiddenColumns: [COUNTRIES_LIST_COLUMNS.Id] as (keyof CountriesRow)[],
    crudComponents: crudItems,
    hideHeaderTitle: true,
    defaultCardOrListView: CardListPage.List,
    largeRightPanel: false,
    hideCardPage: true,
    rowCellOptions,
  };
}
